import { useLayout } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { hocs as pageHocs } from 'modules/page';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useHideCompanyHeader } from 'shared/components';

import { MOBILE_DECISION_PAGE_ID, PAGE_ID } from '../config';
import MobileDecisionPageContent from '../containers/MobileDecisionPageContent';
import { useLeavePage } from '../hooks/useLeavePage';
import useMobileDecisionPageData from '../hooks/useMobileDecisionPageData';

export const MobileDecisionPage: FC = () => {
    const activePageId = useSelector(selectors.navigation.getActivePageId);
    const innerActivePageId = useSelector(selectors.navigation.getInnerActivePageId);

    useLayout({ hasHeader: false, hasDrawer: false });
    useHideCompanyHeader();
    useLeavePage();

    const { isInitialLoading } = useMobileDecisionPageData();

    if (isInitialLoading || activePageId !== PAGE_ID || innerActivePageId !== MOBILE_DECISION_PAGE_ID) {
        return null;
    }

    return <MobileDecisionPageContent />;
};

export default pageHocs.withProtected({ Page: MobileDecisionPage });
